(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-microlot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOlAccordion() {
      document.querySelectorAll('.ol-acc-item.is-open .ol-acc-panel').forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });

      document.querySelectorAll('.ol-acc-trigger').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.ol-acc-item');
          var accordion = btn.closest('.ol-accordion');
          var wasOpen = item.classList.contains('is-open');

          accordion.querySelectorAll('.ol-acc-item.is-open').forEach(function (open) {
            open.classList.remove('is-open');
            open.querySelector('.ol-acc-trigger').setAttribute('aria-expanded', 'false');
            open.querySelector('.ol-acc-panel').style.maxHeight = '0px';
          });

          if (!wasOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            var panel = item.querySelector('.ol-acc-panel');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });
    }

    function initOlFarmLightbox() {
      var lightbox = document.querySelector('[data-ol-farm-lightbox]');
      if (!lightbox) return;

      var img = lightbox.querySelector('.ol-farm-lightbox-img');
      var closeBtn = lightbox.querySelector('.ol-farm-lightbox-close');

      function openLightbox(src, alt) {
        img.src = src;
        img.alt = alt || '';
        img.classList.remove('is-zoomed');
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lightbox.hidden = true;
        img.classList.remove('is-zoomed');
        img.src = '';
        document.body.style.overflow = '';
      }

      document.querySelectorAll('.ol-farm-zoom-trigger').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openLightbox(btn.getAttribute('data-full'), btn.getAttribute('data-alt'));
        });
      });

      img.addEventListener('click', function () {
        img.classList.toggle('is-zoomed');
      });

      closeBtn.addEventListener('click', closeLightbox);

      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    }

    function initOlFarmCarousel() {
      var track = document.querySelector('[data-ol-farm-track]');
      if (!track) return;
      var prevBtn = document.querySelector('[data-ol-farm-prev]');
      var nextBtn = document.querySelector('[data-ol-farm-next]');
      if (!prevBtn || !nextBtn) return;

      function scrollByCard(dir) {
        var card = track.querySelector('.ol-farm-card');
        if (!card) return;
        var amount = card.getBoundingClientRect().width + 20; // matches the track gap
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      nextBtn.addEventListener('click', function () { scrollByCard(1); });

      function updateButtons() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= max;
      }
      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initOlAccordion();
        initOlFarmLightbox();
        initOlFarmCarousel();
      });
    } else {
      initOlAccordion();
      initOlFarmLightbox();
      initOlFarmCarousel();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
